import { jsx as _jsx } from "react/jsx-runtime";
import ArrowRight from '@helsenorge/designsystem-react/components/Icons/ArrowRight';
import LoginButton from './LoginButton';
const LoginBlock = ({ href, icon, children }) => (_jsx(LoginButton, { icon: icon, concept: "normal", fluid: true, htmlMarkup: "a", className: "mt-7 mt-md-8", rightSideIcon: ArrowRight, size: "large", href: href, children: children }));
export default LoginBlock;
